export default __webpack_public_path__ + "static/media/orders_icon.aa0ddc73.svg";